import EmptyResult from "./EmptyResult";


export default EmptyResult;